import { FC } from "react";
import { OnboardingRequestDto } from "../../../api/Api";
import { OnboardingRequestsAdminGrid } from "../../../components/onboardingRequests/adminRequestsGrid";
import { OnboardingRequestBook } from "../../../components/onboardingRequests/types";
import { useOnboardingRequests } from "./queries";
import { ReviewDialog } from "./reviewDialog";

const counterpartyBook: OnboardingRequestBook<OnboardingRequestDto> = {
  entityLabel: "Counterparty",
  entityName: (row) => row.payload?.counterpartyName ?? "",
  resultingEntityId: (row) => row.resultingCounterpartyId,
  entityPath: (id) => `/tradingcounterparties/counterparty/${id}`
};

export const OnboardingRequestsAdmin: FC = () => (
  <OnboardingRequestsAdminGrid
    book={counterpartyBook}
    useRequests={useOnboardingRequests}
    renderReviewDialog={({ open, request, onClose }) => (
      <ReviewDialog open={open} request={request} onClose={onClose} />
    )}
  />
);
